export default __webpack_public_path__ + "static/logo-6d7d6249f458f40187c166b7c2df3a5d.png";